<div [ngClass]="{'page-background': useRebrandedLayout }">
  <div class="container ">
    <ngb-alert
      *ngIf="alert"
      [type]="alert.type"
      (closed)="closeAlert()"
      class="sticky-top"
      style="top: 10px"
      >{{ alert.message }}</ngb-alert
    >

    <div class="row mb-3">
      <div class="col-12">
        <h1 [ngClass]="{'page-title': useRebrandedLayout }" class="text-center mt-4">Date of birth</h1>
      </div>
    </div>

    <div class="row mb-3">
      <div class="col-12 text-center mt-5 mb-3">
        <h5 [ngClass]="{'page-title': useRebrandedLayout }">To change your date of birth, please fill in the field below:</h5>
      </div>
    </div>

    <div class="row mb-5">
      <div class="col-12 col-md-8 col-lg-4 offset-md-2 offset-lg-4 mb-3">
        <form
          #updateBirthDateForm="ngForm"
          (ngSubmit)="save(updateBirthDateForm)"
          novalidate
        >
        <div [ngClass]="{'form-card h-100 p-4': useRebrandedLayout}">
            <div *ngIf="existingDateOfBirth" class="mb-3">
              <label class="form-label" for="dobCurrent"> Current date of birth </label>
              <input
                #dobCurrent="ngModel"
                class="form-control"
                name="dobCurrent"
                [ngModel]="existingDateOfBirth"
                placeholder="Current date of birth"
                readonly
                type="text"
              />
            </div>

            <hr *ngIf="!useRebrandedLayout" class="my-4" />

            <div>
              <label class="form-label" for="dateOfBirth"> New date of birth </label>
              <div class="input-group">
                <input
                  #dateOfBirth="ngbDatepicker"
                  #dateOfBirthModel="ngModel"
                  class="form-control"
                  [class.is-invalid]="
                    dateOfBirthModel.touched && dateOfBirthModel.invalid
                  "
                  name="dateOfBirth"
                  [(ngModel)]="dateOfBirthValue"
                  placeholder="dd/mm/yyyy"
                  [startDate]="{ year: 1990, month: 12 }"
                  ngbDatepicker
                  [required]="true"
                  [maxDate]="today"
                  [minDate]="minDate"
                />
                  <button
                    class="btn btn-outline-secondary calendar"
                    (click)="dateOfBirth.toggle()"
                    type="button"
                  >
                    <fa-icon [icon]="['fas', 'calendar-days']"></fa-icon>
                  </button>
                <div
                  *ngIf="
                    dateOfBirthModel.invalid &&
                    dateOfBirthModel.errors &&
                    dateOfBirthModel.errors.ngbDate &&
                    dateOfBirthModel.errors.ngbDate.invalid
                  "
                  class="invalid-feedback"
                >
                  {{ errorStrings.invalidDateForm }}
                </div>
                <div
                  *ngIf="
                    dateOfBirthModel.invalid &&
                    dateOfBirthModel.errors &&
                    dateOfBirthModel.errors.ngbDate &&
                    dateOfBirthModel.errors.ngbDate.maxDate
                  "
                  class="invalid-feedback"
                >
                  Please enter a date not later than today.
                </div>
                <div
                  *ngIf="
                    dateOfBirthModel.invalid &&
                    dateOfBirthModel.errors &&
                    dateOfBirthModel.errors.ngbDate &&
                    dateOfBirthModel.errors.ngbDate.minDate
                  "
                  class="invalid-feedback"
                >
                  Please enter a date after
                  {{
                    dateOfBirthModel.errors.ngbDate.minDate.minDate.day +
                      "/" +
                      dateOfBirthModel.errors.ngbDate.minDate.minDate.month +
                      "/" +
                      dateOfBirthModel.errors.ngbDate.minDate.minDate.year
                  }}.
                </div>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center">
            <button
              class="btn btn-success text-white btn-lg mt-5 w-100"
              [disabled]="!updateBirthDateForm.valid || loading"
              type="submit"
            >
              <fa-icon
                *ngIf="loading"
                [icon]="['fas', 'spinner']"
                [animation]="'spin'"
                class="me-3"
              ></fa-icon>
              {{ loading ? "Saving" : "Save" }}
            </button>
          </div>
        </form>
      </div>
    </div>

    <div class="row">
      <div class="col-12 d-flex justify-content-start mb-3">
        <a *ngIf="!redirectParams" [routerLink]="['/account']">
          <fa-icon [icon]="['fas', 'angle-left']"></fa-icon> Back to my account
        </a>
        <a
          *ngIf="redirectParams"
          [routerLink]="redirectParams.l"
          [queryParams]="redirectParams.q"
          [fragment]="redirectParams.f"
        >
          <fa-icon [icon]="['fas', 'angle-left']"></fa-icon> Back
        </a>
      </div>
    </div>
  </div>
</div>
